// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'编码:',spanRows:8,type:'input',modelValue:'coding'},
	{ label:'物价编码:',spanRows:8,type:'input',modelValue:'priceCode',op:'selectOptions'},
	{ label:'适用对象:',spanRows:8,type:'select',modelValue:'applicableObjects',op:"ObjectsOptions"},


	{ label:'名称:',spanRows:8,type:'select1',iconDialogVisible:true,modelValue:'chargeProjectName',op:'selectChanceAll'},
	{ label:'拼音简码:',spanRows:16,type:'input',modelValue:'simpCode'},
	
	{ label:'规格说明:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'description'},
	{ label:'财务分类:',spanRows:8,type:'select',modelValue:'financialClassIdName',op:"ClassIdOptions",},
	{ label:'计量单位:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'measurementUnit'},
	
	{ label:'一类最高价:',spanRows:8,type:'input',modelValue:'oneCeilingPrice'},
	{ label:'二类最高价:',spanRows:8,type:'input',modelValue:'twoCeilingPrice'},
	{ label:'三类最高价:',spanRows:8,type:'input',modelValue:'threeCeilingPrice'},
	
	{ label:'费用费别:',spanRows:8,type:'select',iconDialogVisible:true,modelValue:'expenseCategoryId',op:'expenseCategoryIdOptions'},
	{ label:'病案费别:',spanRows:8,type:'select',modelValue:'medicalRecordCostId',op:"CostIdOptions",},
	{ label:'有效状态:',spanRows:8,type:'select',iconDialogVisible:true,modelValue:'state',op:'statusOption'},
	
	{ label:'国家贯标名称:',spanRows:8,type:'input',iconDialogVisible:true,modelValue:'standardName'},
	{ label:'国家贯标编码:',spanRows:8,type:'input',modelValue:'standardCode'},
	
	{ label:'项目内涵:',spanRows:24,type:'textarea',iconDialogVisible:true,modelValue:'projectConnotation'},
	{ label:'除外内容:',spanRows:24,type:'textarea',modelValue:'excludedContent'},
	{ label:'备注说明:',spanRows:24,type:'textarea',iconDialogVisible:true,modelValue:'remake'},
	
	]

